var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpacer = function SvgSpacer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 140,
    viewBox: "0 0 296 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    fill: "#F5F5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    stroke: "#8D83FB",
    strokeDasharray: "4.5 4.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 48H208",
    stroke: "#8D83FB",
    strokeWidth: 3.55,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148 55L148 85",
    stroke: "#8D83FB",
    strokeWidth: 3.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.25 78.75L148 85L141.75 78.75",
    stroke: "#8D83FB",
    strokeWidth: 3.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75 61.25L148 55L154.25 61.25",
    stroke: "#8D83FB",
    strokeWidth: 3.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 92H208",
    stroke: "#8D83FB",
    strokeWidth: 3.55,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpacer);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk2IiBoZWlnaHQ9IjE0MCIgdmlld0JveD0iMCAwIDI5NiAxNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI5NSIgaGVpZ2h0PSIxMzkiIHJ4PSIyLjUiIGZpbGw9IiNGNUY1RkYiIC8+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI5NSIgaGVpZ2h0PSIxMzkiIHJ4PSIyLjUiIHN0cm9rZT0iIzhEODNGQiIKICAgICAgICBzdHJva2UtZGFzaGFycmF5PSI0LjUgNC41IiAvPgogICAgPHBhdGggZD0iTTg4IDQ4SDIwOCIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2Utd2lkdGg9IjMuNTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KICAgIDxwYXRoIGQ9Ik0xNDggNTVMMTQ4IDg1IiBzdHJva2U9IiM4RDgzRkIiIHN0cm9rZS13aWR0aD0iMy41NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgICA8cGF0aCBkPSJNMTU0LjI1IDc4Ljc1TDE0OCA4NUwxNDEuNzUgNzguNzUiIHN0cm9rZT0iIzhEODNGQiIgc3Ryb2tlLXdpZHRoPSIzLjU1IgogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KICAgIDxwYXRoIGQ9Ik0xNDEuNzUgNjEuMjVMMTQ4IDU1TDE1NC4yNSA2MS4yNSIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2Utd2lkdGg9IjMuNTUiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgogICAgPHBhdGggZD0iTTg4IDkySDIwOCIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2Utd2lkdGg9IjMuNTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPC9zdmc+";